package br.com.texeratx.boardgametimeapp.core.i18n

object PtStrings : Strings {

    // ===== Common =====
    override val back = "Voltar"
    override val cancel = "Cancelar"
    override val delete = "Excluir"
    override val edit = "Editar"
    override val save = "Salvar"
    override val ok = "OK"
    override val loading = "Carregando..."
    override val retry = "Tentar novamente"
    override val remove = "Remover"
    override val errorTitle = "Erro"
    override val oops = "Ops"
    override val noImage = "Sem\nimagem"

    // ===== Login =====
    override val appTitle = "Boardgame Timer"
    override val loginSubtitle = "Entre para acessar seus jogos, jogadores e partidas."
    override val labelUsername = "Username"
    override val labelPassword = "Password"
    override val hidePassword = "Ocultar senha"
    override val showPassword = "Mostrar senha"
    override val loggingIn = "Entrando..."
    override val login = "Entrar"
    override val forgotPassword = "Esqueceu a senha?"
    override val noAccountCreateNow = "Não tem conta? Criar agora"

    // ===== Signup =====
    override val signupTitle = "Criar conta"
    override val signupSubtitle = "Crie um clã para salvar seus jogos, jogadores e partidas."
    override val labelClanName = "Nome do clã"
    override val labelEmailOptional = "Email (opcional)"
    override val labelSenha = "Senha"
    override val labelConfirmPassword = "Confirmar senha"
    override val creating = "Criando..."
    override val createAccount = "Criar conta"
    override val hasAccountLogin = "Já tem conta? Fazer login"

    // ===== Forgot Password =====
    override val forgotPasswordTitle = "Recuperar senha"
    override val forgotPasswordInstructions = "Informe o email cadastrado na sua conta. Enviaremos um codigo de 6 digitos para voce criar uma nova senha."
    override val forgotPasswordSuccess = "Se esse email estiver cadastrado, um codigo de 6 digitos foi enviado. Verifique sua caixa de entrada (ou spam)."
    override val enterCode = "Inserir codigo"
    override val labelEmail = "Email"
    override val sending = "Enviando..."
    override val sendInstructions = "Enviar instruções"
    override val backToLogin = "Voltar para login"

    // ===== Reset Password =====
    override val resetPasswordTitle = "Redefinir senha"
    override val resetPasswordInstructions = "Informe o email, o codigo de 6 digitos recebido e a nova senha."
    override val label6DigitCode = "Codigo de 6 digitos"
    override val placeholderCode = "000000"
    override val labelNewPassword = "Nova senha"
    override val labelConfirmNewPassword = "Confirmar nova senha"
    override val resetting = "Redefinindo..."
    override val resetPassword = "Redefinir senha"

    // ===== Home Bottom Bar =====
    override val navGames = "Jogos"
    override val navPlayers = "Players"
    override val navMatches = "Partidas"
    override val navMenu = "Menu"
    override val menuClan = "Clã"
    override val menuStats = "Estatísticas"
    override val menuExpansions = "Expansões"
    override val menuOptions = "Opções"

    // ===== Options =====
    override val optionsTitle = "Opções"
    override val connectionsTitle = "Conexões"
    override val connectSpotify = "Conectar ao Spotify"
    override val termsTitle = "Termos"
    override val termsOfUseSoon = "Termos de uso"
    override val privacyPolicySoon = "Política de privacidade"
    override val languageTitle = "Idioma"
    override val themeTitle = "Tema"
    override val themeDefault = "Padrão"
    override val themeShadow = "Shadow"
    override val themeDefaultDescription = "Visual medieval claro com papel, areia e pedra."
    override val themeShadowDescription = "Visual noturno escuro com sombra, nuvens e poeira."
    override val securityTitle = "Segurança"
    override val changePasswordSoon = "Alterar senha"
    override val securityDescription = "Altere sua senha de acesso."

    // ===== Dashboard =====
    override val dashboardMonthSummary = "Resumo do mês"
    override val dashboardMatches = "Partidas"
    override val dashboardMinutes = "Minutos"
    override val dashboardTopPlayers = "Top Jogadores"
    override val dashboardMostPlayed = "Mais Jogados"
    override val dashboardLastMatches = "Últimas Partidas"
    override val noDataYet = "Sem dados ainda."
    override val noMatchesYet = "Nenhuma partida registrada ainda."
    override val placeholderImg = "IMG"
    override val errorLoading = "Erro ao carregar"
    override fun winsFormat(wins: Int) = "Vitórias: $wins"
    override fun winrateFormat(winrate: Int) = "Winrate: $winrate%"
    override fun matchesCountFormat(count: Int) = "Partidas: $count"

    // ===== Games =====
    override val addGame = "Adicionar jogo"
    override val noGamesYet = "Nenhum jogo cadastrado ainda"
    override val searchGame = "Buscar jogo..."
    override val sortAlphabetical = "A–Z"
    override val sortMostPlayed = "Mais jogados"
    override val filtersTitle = "Filtros"
    override val applyFilters = "Aplicar filtros"
    override val clearFilters = "Limpar filtros"
    override val labelCategory = "Categoria"
    override val labelMode = "Modo"
    override val labelPlayerCount = "Número de jogadores"
    override fun noGamesFoundFor(query: String) = "Nenhum jogo encontrado para \"$query\""
    override fun filterCategoryFormat(value: String) = "Categoria: $value"
    override fun filterModeFormat(value: String) = "Modo: $value"
    override fun filterPlayersFormat(value: String) = "Jogadores: $value"
    override fun gamePlayersRange(min: String, max: String) = "Jogadores: $min–$max"
    override fun gameDurationFormat(duration: String) = "Duração: $duration min"
    override fun gameMatchesPlayedFormat(count: Int) = "Partidas jogadas: $count"
    override fun gameCategoryFormat(category: String) = "Categoria: $category"

    // ===== Create/Edit Game =====
    override val createGameTitle = "Adicionar jogo"
    override val editGameTitle = "Editar jogo"
    override val labelGameName = "Nome do jogo"
    override val sectionGameImage = "Imagem do jogo"
    override val selectImage = "Selecionar imagem"
    override val escolherFonteImagem = "Escolher foto"
    override val camera = "Câmera"
    override val galeria = "Galeria"
    override val previewImage = "Preview imagem"
    override val currentImage = "Imagem atual"
    override val labelMinPlayers = "Min jogadores"
    override val labelMaxPlayers = "Max jogadores"
    override val labelDurationMin = "Duração (min)"
    override val labelBggUrl = "URL do BGG"
    override val labelManualUrl = "URL do manual"
    override val labelSpotifyUrl = "Playlist do Spotify"
    override val spotifyUrlHint = "Cole o link compartilhado pelo Spotify (ex: open.spotify.com/playlist/...)"
    override val sectionGameOwners = "Donos do jogo"
    override val loadingPlayers = "Carregando jogadores..."
    override val labelAddOwner = "Adicionar dono"
    override val saveGame = "Salvar jogo"
    override val saveChanges = "Salvar alterações"
    override val labelCatalogGame = "Jogo do catálogo"
    override val pickCatalogGame = "Buscar no catálogo"
    override val catalogSearchTitle = "Buscar jogo no catálogo"
    override val catalogSearchHint = "Digite o nome do jogo"
    override val catalogSearchTypePrompt = "Digite para buscar"
    override val catalogSearchNoResults = "Nenhum jogo encontrado"
    override val selectCatalogFirst = "Selecione um jogo do catálogo"

    // ===== Game Detail =====
    override val gameDetailTitle = "Detalhes do Jogo"
    override val editGame = "Editar jogo"
    override val deleteGame = "Excluir jogo"
    override val deleteGameConfirm = "Tem certeza que deseja excluir este jogo?"
    override val labelPlayers = "Jogadores"
    override val labelAvgDuration = "Duração média"
    override val createExpansionBtn = "Criar expansão"
    override val sectionStatistics = "Estatísticas"
    override val statMatches = "Partidas"
    override val statThisYear = "Neste ano"
    override val statLastMatch = "Última partida"
    override val statFirstMatch = "Primeira partida"
    override val statAverageMatchDuration = "Duração média"
    override val statLongestMatch = "Maior partida"
    override val statShortestMatch = "Menor partida"
    override val sectionScoreStats = "Pontuação"
    override val statHighestScore = "Maior pontuação"
    override val statWinnerAverageScore = "Média de pontos do vencedor"
    override val statLowestScore = "Menor pontuação"
    override val statScorePlayers = "Jogador(es)"
    override val sectionGameWinners = "Vencedores"
    override val emptyGameWinners = "Ainda nao ha vitorias registradas para este jogo."
    override val sectionOwners = "Donos"
    override val emptyOwners = "Nenhum dono cadastrado para este jogo."
    override val sectionMatchHistory = "Histórico de partidas"
    override val emptyMatchHistory = "Ainda não há partidas registradas para este jogo."
    override fun gameWinnerWinsFormat(wins: Int) = "$wins vitorias"
    override fun matchDurationDisplay(duration: String) = "Duração: $duration"
    override fun expansionCountFormat(count: Int) = "$count expansão(ões)"
    override fun pointsFormat(points: Int) = "$points pts"

    // ===== Players =====
    override val addPlayer = "Adicionar jogador"
    override fun playersTitleFormat(count: Int) = "Jogadores ($count)"
    override val searchPlayer = "Buscar jogador..."
    override val sortPlayersAZ = "A-Z"
    override val sortPlayersZA = "Z-A"
    override val filterWithNickname = "Com apelido"
    override val filterWithoutNickname = "Sem apelido"
    override val filterWithPhoto = "Com foto"

    // ===== Create/Edit Player =====
    override val createPlayerTitle = "Adicionar jogador"
    override val editPlayerTitle = "Editar jogador"
    override val labelName = "Nome"
    override val labelNicknameOptional = "Apelido (opcional)"
    override val sectionPhotoAvatar = "Foto / avatar"
    override val previewAvatar = "Preview avatar"
    override val labelBirthdayOptional = "Data de nascimento (opcional)"
    override val labelPhoneOptional = "Telefone (opcional)"
    override val savePlayer = "Salvar jogador"

    // ===== Player Detail =====
    override val playerDetailTitle = "Detalhes do Jogador"
    override val deletePlayer = "Excluir jogador"
    override val deletePlayerConfirm = "Tem certeza que deseja excluir este jogador?"
    override val labelNickname = "Apelido"
    override val labelBirthday = "Nascimento"
    override val labelPhone = "Telefone"
    override val sectionPlayerStatistics = "Estatisticas"
    override val sectionWinsByGame = "Jogos vencidos"
    override val sectionGamesOwned = "Jogos que tem"
    override val sectionRecentMatches = "Ultimas partidas"
    override val sectionMatchups = "Confrontos"
    override val matchupPeriodTotal = "Historico"
    override val matchupPeriodCurrentYear = "Ano atual"
    override val matchupTopRivals = "Top 5 rivais"
    override val emptyWinsByGame = "Este jogador ainda nao possui vitorias registradas por jogo."
    override val emptyGamesOwned = "Este jogador nao possui jogos cadastrados."
    override val emptyRecentMatches = "Este jogador ainda nao participou de partidas."
    override val emptyMatchups = "Sem historico suficiente de confrontos neste periodo."
    override val matchupMostDefeated = "Mais venceu"
    override val matchupMostLostTo = "Mais perdeu"
    override val matchupMostPlayedTogether = "Mais jogou junto"
    override val matchupBestGame = "Melhor jogo para voce"
    override val matchupWorstGame = "Pior jogo para voce"
    override val playerStatWins = "Vitorias"
    override val playerStatParticipations = "Participacoes"
    override val playerStatHoursPlayed = "Horas jogadas"
    override val playerStatWinsYear = "Vitorias no ano"
    override val playerStatParticipationsYear = "Participacoes no ano"
    override val playerStatHoursPlayedYear = "Horas jogadas no ano"
    override fun playerGameWinsFormat(wins: Int) = "$wins vitorias"
    override fun matchupRecordFormat(wins: Int, losses: Int) = "Seu retrospecto: $wins vitorias / $losses derrotas"
    override fun matchupWinRateFormat(pct: Int) = "Sua taxa de vitoria: $pct%"
    override fun matchupDominanceFormat(value: Int) = "Seu saldo (V-D): ${if (value > 0) "+" else ""}$value"
    override fun matchupLastMatchFormat(date: String) = "Ultima partida: $date"
    override fun matchupBestGameFormat(gameName: String) = "Melhor jogo para voce: $gameName"
    override fun matchupWorstGameFormat(gameName: String) = "Pior jogo para voce: $gameName"

    // ===== Matches =====
    override val matchesTitle = "Partidas"
    override val searchMatch = "Buscar partida..."
    override val matchFiltersTitle = "Filtros de partidas"
    override val matchSortDateDesc = "Mais recentes"
    override val matchSortDateAsc = "Mais antigas"
    override val matchSortDurationDesc = "Maior duração"
    override val matchSortDurationAsc = "Menor duração"
    override val matchFilterGames = "Jogos"
    override val matchFilterPlayers = "Jogadores"
    override val matchFilterDuration = "Duração"
    override val matchFilterDate = "Data"
    override val matchFilterMinDuration = "Duração mínima (min)"
    override val matchFilterMaxDuration = "Duração máxima (min)"
    override val matchFilterStartDate = "Data inicial"
    override val matchFilterEndDate = "Data final"
    override val matchDatePlaceholder = "dd/MM/aaaa"
    override val matchFilterDurationRangeInvalid = "A duração mínima não pode ser maior que a máxima."
    override val matchFilterDateRangeInvalid = "A data inicial não pode ser maior que a final."
    override fun matchFilterGameFormat(gameName: String) = "Jogo: $gameName"
    override fun matchFilterPlayerFormat(playerName: String) = "Jogador: $playerName"
    override fun matchFilterDurationRangeFormat(min: String, max: String) = "Duração: $min-$max min"
    override fun matchFilterDateRangeFormat(start: String, end: String) = "Data: $start - $end"

    // ===== Match Detail =====
    override val matchDetailTitle = "Detalhes da Partida"
    override val editMatch = "Editar partida"
    override val sectionExpansions = "Expansões"
    override val loadingExpansions = "Carregando expansões..."
    override val noExpansionsFound = "Nenhuma expansão encontrada"
    override val sectionPlayers = "Jogadores"
    override val winner = "Vencedor"
    override val deleteMatch = "Excluir partida"
    override val deleteMatchConfirm = "Tem certeza que deseja excluir esta partida? Esta ação não pode ser desfeita."
    override fun positionFormat(position: Int) = "${position}º"

    // ===== Match Edit =====
    override val editMatchTitle = "Editar Partida"
    override val sectionMatch = "Partida"
    override val labelDate = "Data"
    override val labelTimeHHmm = "Hora (HH:mm)"
    override val labelObservation = "Observação"
    override val addPlayerBtn = "Adicionar jogador"
    override val removePlayer = "Remover jogador"
    override val noExpansionsForGame = "Este jogo não possui expansões"
    override val dialogAddPlayer = "Adicionar jogador"
    override val labelGame = "Jogo"

    // ===== Start Match Setup =====
    override val startMatchSetupTitle = "Configurar partida"
    override val sectionGame = "Jogo"
    override val noPlayersFound = "Nenhum jogador encontrado."
    override val sectionExpansionsOptional = "Expansões (opcional)"
    override val noExpansionsRegistered = "Esse jogo não tem expansões cadastradas."
    override val startMatch = "Iniciar partida"
    override val errorViewModelCreation = "Falha ao criar StartMatchSetupViewModel. Veja o console."

    // ===== Active Match =====
    override val activeMatchTitle = "Partida ativa"
    override val matchInProgress = "Partida em andamento"
    override val noActiveMatch = "Nenhuma partida ativa no momento."
    override val pause = "Pausar"
    override val endMatch = "Encerrar partida"
    override val statusPaused = "PAUSADA"
    override val resume = "Continuar"
    override val cancelMatch = "Cancelar partida"
    override val matchFinished = "Partida finalizada!"
    override val firstPlayer = "Primeiro jogador"
    override val positionFirst = "1º"
    override val none = "Nenhuma"
    override val sectionCurrentGameStats = "Estatísticas deste jogo"
    override val bestScoreForGame = "Melhor pontuação"
    override val averageScoreForGame = "Pontuação média"
    override val worstWinningScoreForGame = "Pior pontuação de vitória"
    override val topWinnerForGame = "Quem mais venceu"
    override fun winsForPlayerFormat(wins: Int) = "$wins vitórias"
    override val noStatsForGameYet = "Ainda não há histórico suficiente para este jogo."
    override val avgDurationForGame = "Tempo médio"
    override val minDurationForGame = "Tempo mínimo"
    override val maxDurationForGame = "Tempo máximo"

    // ===== Match Score =====
    override val scoreTitle = "Pontuação"
    override val sectionPlayerScores = "Pontuação por jogador"
    override val labelPts = "Pts"
    override val labelObservationOptional = "Observação (opcional)"
    override val required = "Obrigatório"
    override val invalid = "Inválido"
    override val saveMatch = "Salvar partida"
    override val snackbarMatchSaved = "Partida salva!"
    override val snackbarErrorSavingMatch = "Erro ao salvar partida"
    override fun invalidScoreFor(playerName: String) = "Pontuação inválida para: $playerName"
    override fun matchDateDisplay(date: String) = "Data: $date"
    override fun matchDurationMinFormat(minutes: Long) = "Duração: $minutes min"

    // ===== Active Match Summary =====
    override val matchSummaryTitle = "Resumo da partida"
    override val matchEncerrada = "Partida encerrada!"
    override val conclude = "Concluir"
    override val noFinishedMatch = "Nenhuma partida finalizada para mostrar."
    override fun matchGameFormat(gameName: String) = "Jogo: $gameName"
    override fun matchElapsedFormat(elapsed: String) = "Duração: $elapsed"

    // ===== Expansions =====
    override val expansionsTitle = "Expansões"
    override val createExpansionTitle = "Criar expansão"
    override val editExpansionTitle = "Editar expansão"
    override val labelExpansionName = "Nome da expansão"
    override val sectionExpansionImage = "Imagem da expansão"
    override val previewExpansionImage = "Preview imagem expansão"
    override val labelBggUrlOptional = "BGG URL (opcional)"
    override val saveExpansion = "Salvar expansão"
    override val selectGame = "Selecione um jogo"
    override val labelImageUrlOptional = "Image URL (opcional)"
    override fun errorFormat(error: String) = "Erro: $error"
    override val bgg = "BGG"
    override val questionMark = "?"

    // ===== Stats =====
    override val statsTitle = "Estatísticas"
    override val tabGlobal = "Global"
    override val tabYear = "Ano"
    override val tabDuration = "Duração"
    override val totalTimePlayed = "Total de tempo jogado"
    override val sectionMostPlayedGames = "Jogos mais jogados"
    override val sectionRankingWinrate = "Ranking (winrate)"
    override val loadingYearHistory = "Carregando histórico do ano..."
    override val statTimePlayedLabel = "Tempo jogado"
    override val mostPlayedYear = "Mais jogados no ano"
    override val winsYear = "Vitórias no ano"
    override val matchesPerMonth = "Partidas por mês"
    override val durationPerGame = "Duração por jogo"
    override val loadingDurationStats = "Carregando duração por jogo..."
    override fun rankingWinrateFormat(pct: Int, wins: Int) = "$pct% • ${wins}W"
    override fun participationsFormat(count: Int) = "Participações: $count"
    override fun previousYearFormat(year: Int) = "← $year"
    override fun nextYearFormat(year: Int) = "$year →"
    override fun gameDurationStatsFormat(count: Int, avg: Int, min: Int, max: Int) =
        "Partidas: $count • Média: $avg min • Min: $min • Max: $max"
    override fun monthLabel(month: Int) = "Mês $month"
    override fun countFormat(count: Int) = "${count}x"
    override fun winratePercentFormat(pct: Int) = "$pct%"
    override fun winsCountFormat(wins: Int) = "${wins}V"
    override val monthsAbbreviations = listOf("jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez")
    override val sectionSummary = "Resumo"
    override val sectionCategoriesMostPlayed = "Categorias mais jogadas"
    override val sectionPlayerMinutes = "Tempo por jogador"
    override val sectionParticipations = "Participações"
    override val uniqueGamesLabel = "jogos diferentes"
    override fun minutesFormat(minutes: Int): String {
        val h = minutes / 60
        val m = minutes % 60
        return if (h > 0) "${h}h ${m}min" else "${m}min"
    }
    override fun participationsCountFormat(count: Int) = "$count partidas"

    // ===== Clan =====
    override val clanTitle = "Clã"
    override val saving = "Salvando..."

    // ===== Dialogs =====
    override val dialogFinishMatch = "Encerrar partida"
    override val dialogFinishMatchConfirm = "Tem certeza que deseja encerrar a partida ativa?"
    override val finish = "Encerrar"
    override val dialogActiveMatchInProgress = "Partida ativa em andamento"
    override val dialogActiveMatchChoice = "Você já tem uma partida ativa. O que deseja fazer?"
    override val continueCurrent = "Continuar atual"
    override val replace = "Substituir"

    // ===== Active Match Mini Player =====
    override val statusRunning = "Rodando"
    override val statusFinished = "Finalizada"
    override val activeMatchFallback = "Partida ativa"
    override fun matchTimeStatusFormat(time: String, status: String) = "Tempo: $time • $status"
    override val openMatch = "Abrir partida"
    override val finishMatch = "Encerrar partida"

    // ===== ViewModel Error Messages =====
    override val usernameRequired = "Username é obrigatório"
    override val passwordRequired = "Senha é obrigatória"
    override val usernameCannotBeEmpty = "Username não pode ficar vazio"
    override val clanNameRequired = "Nome do clã é obrigatório"
    override val clanNameCannotBeEmpty = "Nome do clã não pode ficar vazio"
    override val passwordsDoNotMatch = "As senhas não conferem"
    override val emailRequired = "Email é obrigatório"
    override val invalidOrExpiredCode = "Código inválido ou expirado"
    override val codeMustBe6Digits = "O código deve ter 6 dígitos"
    override val newPasswordRequired = "Nova senha é obrigatória"
    override val newPasswordMustBeDifferent = "A nova senha deve ser diferente da senha atual"
    override val errorLoadingGames = "Erro ao carregar jogos"
    override val errorCreatingGame = "Erro ao criar jogo"
    override val errorSavingGame = "Erro ao salvar"
    override val errorDeletingGame = "Não foi possível deletar o jogo."
    override val unknownError = "Erro desconhecido"
    override val errorLoadingPlayers = "Erro ao carregar jogadores"
    override val errorCreatingPlayer = "Erro ao criar jogador"
    override val errorSavingPlayer = "Erro ao salvar jogador"
    override val errorDeletingPlayer = "Não foi possível deletar o jogador."
    override val errorLoadingMatchDetails = "Erro ao carregar detalhes da partida"
    override val errorSavingMatch = "Erro ao salvar partida"
    override val errorCreatingExpansion = "Erro ao criar expansão"
    override val errorUpdatingExpansion = "Erro ao atualizar expansão"
    override val errorLoadingExpansion = "Erro ao carregar expansão"
    override val errorLoadingExpansions = "Erro ao carregar expansões"
    override val expansionCreatedSuccess = "Expansão criada com sucesso!"
    override val expansionUpdatedSuccess = "Expansão atualizada com sucesso!"
    override val errorLoadingStats = "Erro ao carregar estatísticas"
    override val errorLoadingDurationStats = "Erro ao carregar duração por jogo"
    override val errorLoadingYearHistory = "Erro ao carregar histórico do ano"
    override val errorLoadingClan = "Erro ao carregar clã"
    override val errorLoadingOwners = "Erro ao carregar donos"
    override val errorUploadingImage = "Falha ao enviar imagem"
    override val gameNameRequired = "Nome é obrigatório"
    override val categoryAndModeRequired = "Categoria e modo são obrigatórios"
    override val selectAtLeastOneOwner = "Selecione pelo menos um dono"
    override val minCannotBeGreaterThanMax = "Min não pode ser maior que Max"
    override val expansionNameRequired = "Nome da expansão é obrigatório"
    override val invalidDateFormat = "Data inválida. Use dd/MM/aaaa"
    override val invalidBirthday = "Data de nascimento inválida"
    override val playerNameRequired = "Nome é obrigatório"
    override val selectAGame = "Selecione um jogo"
    override val selectAtLeastOnePlayer = "Selecione ao menos 1 jogador"
    override val invalidPlayersAndScores = "Informe jogadores e scores válidos"
    override val errorDeletingMatch = "Não foi possível deletar a partida."
    override val matchDeletedSuccess = "Partida excluída com sucesso!"
    override val playerCreatedSuccess = "Jogador criado com sucesso"
    override val errorSavingClan = "Erro ao salvar"
    override val passwordChangedSuccess = "Senha alterada com sucesso"
    override val spotifyDeviceTitle = "Dispositivo Spotify"
    override val spotifyRefresh = "Atualizar"
    override val spotifyNoDevices = "Nenhum dispositivo encontrado. Abra o Spotify em algum aparelho (celular/PC) e tente atualizar."
    override val spotifyDeviceActive = " • Ativo agora ✅"
    override val spotifyDeviceRestricted = " • Restrito ⚠️"
    override val spotifyDoNotPlay = "Não tocar música"
    override val spotifyReconnectRequired = "Sua conexão com o Spotify expirou. Reconecte em Opções > Conexões."
    override val spotifyOnlyInApp = "Recurso disponível apenas no app (Android/iOS)."
    override val durationLabel = "Duração"
    override fun durationMinutesFormat(min: Int) = "$min min"
}
